import React, { useState } from "react";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Divider, IconButton, Popover, Stack, Typography } from "@mui/material";
import { CharacteristicDef } from "store/types";

import { LocalCharacteristicData } from "../context/DealCreateContext";
import { MultipleCharacteristicPopup } from "./MultipleCharacteristicPopup";

interface Props {
  characteristic: CharacteristicDef;
  entries: LocalCharacteristicData[];
  onEntriesChange: (entries: LocalCharacteristicData[]) => void;
}

export const MultipleCharacteristicField: React.FC<Props> = ({ characteristic, entries, onEntriesChange }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  return (
    <>
      <Stack sx={{ gap: "10px" }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontSize: "16px", lineHeight: "24px" }}>
            {characteristic.name}
            {characteristic.required && (
              <Typography component="span" sx={{ color: "#d32f2f", ml: "2px" }}>
                *
              </Typography>
            )}
          </Typography>
        </Stack>
        <Divider sx={{ borderColor: "#DBE8F5" }} />
        <Stack sx={{ flexDirection: "row", gap: "10px", justifyContent: "space-between" }}>
          <Stack sx={{ flexDirection: "row", flexWrap: "wrap", gap: "10px", flexGrow: 1, alignItems: "flex-start" }}>
            {entries.length ? (
              entries.map((item) => (
                <Stack
                  sx={{ flexDirection: "row", borderRadius: "20px", p: "4px", bgcolor: "#F6F8FC" }}
                  key={item.localId}
                >
                  <Typography sx={{ color: "#071F35", lineHeight: "16px", fontSize: "12px", mr: "4px" }}>
                    {item.value}
                  </Typography>
                  <Typography sx={{ fontWeight: 700, color: "#071F35", lineHeight: "16px", fontSize: "12px" }}>
                    {item.percentage}
                  </Typography>
                  <Typography sx={{ color: "#071F35", lineHeight: "16px", fontSize: "12px" }}>%</Typography>
                </Stack>
              ))
            ) : (
              <Stack sx={{ flexDirection: "row", borderRadius: "20px", p: "4px", bgcolor: "#F6F8FC" }}>
                <Typography sx={{ color: "#071F35", lineHeight: "16px", fontSize: "12px" }}>No value</Typography>
              </Stack>
            )}
          </Stack>
          <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
            <EditOutlinedIcon />
          </IconButton>
        </Stack>
      </Stack>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        marginThreshold={100}
        keepMounted={false}
        onClose={() => setAnchorEl(null)}
      >
        <MultipleCharacteristicPopup
          characteristic={characteristic}
          initialEntries={entries}
          onApply={(updated) => {
            onEntriesChange(updated);
            setAnchorEl(null);
          }}
          onClose={() => setAnchorEl(null)}
        />
      </Popover>
    </>
  );
};
